import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { routes } from "./routeList";
import ProtectedRoute from "./protectesRoute";
import PublicRoute from "./publicRoute";

const AppRouter = () => {


  const RoutesComponent = () => {

    const location = useLocation();

    useEffect(() => {
      const selectedRoute = routes.find(route => route?.path === window.location.pathname);
      document.title = selectedRoute?.title;
    }, [location?.pathname])

    return (
      <Routes>
         {routes.map(({ path, element, protectedRoute, publicRoute }, index) => {
          if (protectedRoute) {
            return (
              <Route
                key={index}
                path={path}
                element={
                  <ProtectedRoute>
                    {element}
                  </ProtectedRoute>
                }
              />
            );
          }
          if(publicRoute){
            return (
              <Route
                key={index}
                path={path}
                element={
                  <PublicRoute>
                    {element}
                  </PublicRoute>
                }
              />
            );
          }
          return <Route key={index} path={path} element={element} />;
        })}
      </Routes>
    );
  };

  return (
    <BrowserRouter>
      <RoutesComponent />
    </BrowserRouter>
  );
};

export default AppRouter;